import { render, staticRenderFns } from "./BindPhoneDialog.vue?vue&type=template&id=c3b9fd7e"
import script from "./BindPhoneDialog.vue?vue&type=script&lang=js"
export * from "./BindPhoneDialog.vue?vue&type=script&lang=js"
import style0 from "./BindPhoneDialog.vue?vue&type=style&index=0&id=c3b9fd7e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports